import React from 'react'
import { connect } from 'react-redux'
import { selectOptions } from '../../containers/App/selectors'
import get from 'lodash/get'
import { getOptionFromArgs } from './helpers'

const OptionsHOC = WrappedComponent => {
  const HOC = ({ options, ...parentProps }) => {
    const getOption = getOptionFromArgs(options)

    // Used to retrieve options object with resolved values
    const getOptionObject = path => {
      const object = get(options, path, {})

      return Object.keys(object).reduce(
        (map, key) => ((map[key] = getOption(`${path}.${key}`)), map),
        {}
      )
    }

    const props = {
      ...parentProps,
      getOption,
      getOptionObject
    }

    return <WrappedComponent {...props} />
  }

  const mapStateToProps = state => ({
    options: selectOptions(state),
  })

  return connect(
    mapStateToProps,
    null
  )(HOC)
}

export default OptionsHOC



// WEBPACK FOOTER //
// ./src/hocs/OptionsHOC/index.js